import React from "react";
import styled, { css } from "styled-components";
import { color } from "../templates/ui";
const StyledTableRow = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-top: 1px dashed ${color.gray.base};

  &:nth-child(2) {
    @media only screen and (max-width: 768px) {
      border: none;
      padding: 0 0 20px 0;
    }
  }

  ${props => props.isLoading &&
    css `
      border-top: 1px solid rgba(0, 31, 69, 0.1);
    `};
`;
const TableRow = Props => (React.createElement(StyledTableRow, Object.assign({}, Props)));
export default TableRow;
